import type { ListCampaignRow } from 'modules/campaign/row';
import { SupplierTitle } from 'modules/supplier/supplier/components';
import { periodColumn } from 'components/columns';
import { BlockWidget, BoundStates, ClientTitle, Period } from 'components';
import { EnterpriseLink } from 'components/EnterpriseLink';
import { sepFormat } from 'utilities';
import { TableColumns } from '@ff-it/ui';
import { PlanRowKindIcon } from 'modules/campaign/common/PlanRowKindIcon';

const sumProps = {
  width: 100,
  cellProps: {
    textAlign: 'end' as const,
    className: 'px-1',
  },
};

export const columns: TableColumns<ListCampaignRow> = [
  {
    key: 'id',
    width: 25,
    cellProps: {
      className: 'px-0 text-center',
    },
    render: ({ id, kind, block: { id: blockId, campaign } }: ListCampaignRow) => (
      <EnterpriseLink to={`/planning/campaigns/${campaign.id}/planning/${blockId}?rowId=${id}`}>
        <PlanRowKindIcon kind={kind} />
      </EnterpriseLink>
    ),
    sortable: false,
  },
  {
    content: 'Block',
    key: 'block.code',
    minWidth: 150,
    cellProps: { className: 'py-0  pl-0' },
    render: ({ block }) => <BlockWidget {...block} campaign_id={block.campaign.id} link target="_self" />,
    sortable: true,
  },
  {
    content: 'Client',
    key: 'block.client',
    cellProps: {
      className: 'py-1',
    },
    render: ({ block: { campaign } }) => <ClientTitle {...campaign} />,
  },
  {
    content: 'Supplier',
    key: 'supplier',
    cellProps: {
      className: 'py-1',
    },
    render: ({ supplier }) => (supplier ? <SupplierTitle {...supplier} /> : null),
  },

  {
    ...periodColumn,
    sortable: false,
    render: ({
      sums: {
        planned: { date_from, date_to },
      },
    }) => <Period date_from={date_from} date_to={date_to} />,
  },
  {
    ...sumProps,
    content: 'Client total',
    key: 'sums.target.client_net_total',
    render: ({ state, sums }) => sepFormat(!state.canceled ? sums.target.client_net_total : null),
  },
  {
    ...sumProps,
    content: 'Provider total',
    key: 'sums.target.provider_net_total',
    render: ({ state, sums }) => sepFormat(!state.canceled ? sums.target.provider_net_total : null),
  },

  {
    ...sumProps,
    content: 'Revenue',
    key: 'sums.target.revenue',
    render: ({ state, sums }) => sepFormat(!state.canceled ? sums.target.revenue : null),
  },
  {
    width: 40,
    cellProps: {
      flush: true,
      textAlign: 'center',
      className: 'pr-0',
    },
    key: 'state',
    render: ({ id, state }: ListCampaignRow) => (!state.canceled ? <BoundStates {...state} row={id} /> : null),
  },
];
